import { gql } from "@apollo/client";

export const PLANS_QUERY = gql`
  query Plans {
    plans {
      id
      name
      description
      amount
      currency
      interval
      interval_count
      features
      limits
      active
      is_default
      prorata_amount
      stripe_product_id
      stripe_price_id
      created_at
      updated_at
      deleted_at
    }
  }
`;

// Products Query
